import * as React from "react";

import { DataTable } from "src/components/common";
import { Button } from "src/components/buttons";
import { Form, Modal, Select, Tooltip } from "antd";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { AdminPermissions } from "src/common/Permissions";
import { ActionIcon } from "src/components/forms/ActionColumnIconsAndButton";

interface IProps {
	openModal: boolean;
	selectedUsers: DatasetUserDTO[];
	datasetList: DatasetDTO[];
	roles: RoleDTO[];
	datasetRoleItemList: DatasetRoleItemDTO[];
	datasetRoleItem: DatasetRoleItemDTO;
	closeModal?: () => void;
	onRoleChanged?: (value: number) => void;
	onDatasetChanged?: (value: number) => void;
	onAddRoleItem?: () => void;
	onRemoveRoleItem?: (datasetRoleItem: DatasetRoleItemDTO) => void;
	errorMsg: string;
	onSave?: () => void;
	loading?: boolean;
}

const DatasetModal: React.FC<IProps> = (props: IProps) => {
	let dataList: any[] = [];
	if (
		props.datasetRoleItemList !== undefined &&
		props.datasetRoleItemList.length > 0
	) {
		dataList = dataList.concat(props.datasetRoleItemList).map((dr) => ({
			...dr,
			roleName: getRoleName(dr.roleId!),
			datasetName: getDatasetName(dr.datasetId!),
		}));
	}

	const datasetRoleItemColumns = [
		{
			Header: <Tooltip title="Role">Role</Tooltip>,
			accessor: "roleName",
		},
		{
			Header: <Tooltip title="Dataset">Dataset</Tooltip>,
			accessor: "datasetName",
		},
		{
			Header: <Tooltip title="Actions">Actions</Tooltip>,
			Cell: (rowInfo: any) => (
				<ActionIcon
					onClick={() => props.onRemoveRoleItem!(rowInfo.original)}
					type="delete"
					title="Delete"
				/>
			),
		},
	];

	return (
		<Modal
			visible={props.openModal}
			title="Add Datasets"
			onCancel={props.closeModal}
			okText="Save"
			width={700}
			onOk={props.onSave}
			okButtonProps={{
				disabled:
					(props.datasetRoleItemList &&
						props.datasetRoleItemList.length === 0) ||
					props.loading,
			}}
		>
			<div className="row">
				<div className="form-group d-flex col-12 mb-0">
					<div className="form-group col-5">
						<label>Role</label>
						<Form.Item>
							<AuthorizationWrapper
								type="disable"
								permissions={[AdminPermissions.EditOrganizationUser]}
							>
								<Select
									onChange={props.onRoleChanged}
									value={props.datasetRoleItem.roleId}
								>
									{props.roles.map((item) => {
										if (item.roleTypeCode === "DatasetRoleType") {
											return (
												<Select.Option key={item.id} value={item.id}>
													<span data-id={item.id}>{item.name}</span>
												</Select.Option>
											);
										}
										return null;
									})}
								</Select>
							</AuthorizationWrapper>
						</Form.Item>
					</div>
					<div className="form-group col-5">
						<label>Dataset</label>
						<Form.Item>
							<AuthorizationWrapper
								type="disable"
								permissions={[AdminPermissions.EditOrganizationUser]}
							>
								<Select
									onChange={props.onDatasetChanged}
									value={props.datasetRoleItem.datasetId}
								>
									{props.datasetList.map((item) => (
										<Select.Option key={item.id} value={item.id}>
											<span data-id={item.id}>{item.name}</span>
										</Select.Option>
									))}
								</Select>
							</AuthorizationWrapper>
						</Form.Item>
					</div>
					<div className="form-group col-2 d-flex align-items-end">
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationUser]}
						>
							<Button onClick={props.onAddRoleItem} className="btn-primary">
								Add
							</Button>
						</AuthorizationWrapper>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="form-group d-flex justify-content-center col-12 text-danger mb-0">
					<p>{props.errorMsg}</p>
				</div>
			</div>
			<div>
				<DataTable
					data={dataList}
					columns={datasetRoleItemColumns}
					showPagination={false}
				/>
			</div>
		</Modal>
	);

	function getRoleName(roleId: number): string {
		const value = props.roles.find((i) => i.id === roleId);
		if (value === undefined) {
			return "Undefined";
		}
		if (value.name === undefined) {
			return "Undefined";
		}
		return value.name;
	}

	function getDatasetName(datasetId: number): string {
		const value = props.datasetList.find((i) => i.id === datasetId);
		if (value === undefined) {
			return "Undefined";
		}
		if (value.name === undefined) {
			return "Undefined";
		}
		return value.name;
	}
};

export default DatasetModal;
